import React from "react";

// styles
import styles from "./CustomCheckbox.module.scss";
import { useAppSelector } from "../../hooks/reduxHooks";
import { selectColor } from "../../redux/slices/enviromentSlice/EnviromentSlice.selectors";
import { useState } from "react";
import colors from "../../styles/variables.module.scss";
import "./CustomCheckbox.scss";
import { Checkbox, FormControlLabel} from "@mui/material";

// const GreenCheckbox = withStyles({
//   root: {
//     color: "#005aeb",
//     "&$checked": {
//       color: "#005aeb"
//     }
//   },
//   checked: {}
// })((props: CheckboxProps) => <Checkbox color="default" {...props} />);

interface propsI {
  label: string;
  onChange?: (checked: boolean) => void;
  name: string;
  checked?: boolean;
}

const CustomCheckbox: React.FC<propsI> = (props) => {
  const mainColor = useAppSelector(selectColor);

  const [checked, setChecked] = useState(props.checked ?? false);
  return (
    <div>
      {/* <FormControlLabel
        // className={styles.formControlLabel}
        control={
          <Checkbox
            name={props.name}
            style={{ color: mainColor || colors.primaryBlue }}
            checked={checked}
            onChange={(event) => {
              setChecked(event.currentTarget.checked);
              if (props.onChange) props.onChange(event.currentTarget.checked);
            }}
          />
        }
        label={props.label}
      /> */}
      <FormControlLabel
        className={styles.formControlLabel}
        control={
          <Checkbox
            name={props.name}
            style={{ color: mainColor || colors.primaryBlue }}
            checked={checked}
            onChange={(event) => {
              setChecked(event.currentTarget.checked);
              if (props.onChange) props.onChange(event.currentTarget.checked);
            }}
          />
        }
        label={<span className={styles.label}>{props.label}</span>}
      />
    </div>
  );
};

export default CustomCheckbox;
